import { Button, type ButtonProps } from 'antd';
import type { ReactNode } from 'react';
import { IconClose } from './Icon';
import { Tristate } from './utils/tristateTask';
import { useAsyncAction } from './utils/useAsyncAction';

type Props = ButtonProps & {
  onClick?: () => Promise<unknown>;
  children?: ReactNode;
  timeoutMs?: number;
};

export function AsyncButton({ onClick, children, disabled, timeoutMs, ...props }: Props) {
  const { status, run } = useAsyncAction();

  const handleClick = () => {
    if (onClick) run(onClick, timeoutMs);
  };

  let { icon } = props;
  if (status === Tristate.FAILURE) icon = <IconClose />;

  return (
    <Button
      {...props}
      onClick={handleClick}
      loading={status === Tristate.SPINNING}
      icon={icon}
      disabled={disabled || status === Tristate.SPINNING}
    >
      {children}
    </Button>
  );
}
